export const HomePageExplore = [
    {
        tag: 'Free',
        courses : [
            {
                heading : "Learn HTML",
                description : "Get started with the basics of HTML to build and structure web pages effectively.",
                level : 'Beginner',
                lessionNumber : 10
            },
            {
                heading : "Learn CSS",
                description : "Dive into CSS fundamentals and learn how to style and layout web pages professionally.",
                level : 'Beginner',
                lessionNumber : 12
            },
            {
                heading : "Responsive Web design",
                description : "Master responsive design principles to create web pages that look great on any device.",
                level : 'Intermediate',
                lessionNumber : 8
            },
        ]
    },
    {
        tag: 'New to coding',
        courses : [
            {
                heading : "HTML",
                description : "Learn the essentials of HTML for creating structured and accessible web content.",
                level : 'Beginner',
                lessionNumber : 8
            },
            {
                heading : "CSS",
                description : "Explore the basics of CSS to add styling and layout to your web projects.",
                level : 'Beginner',
                lessionNumber : 10
            },
            {
                heading : "Responsive ",
                description : "Understand responsive web design to build websites that adapt seamlessly to all screen sizes.",
                level : 'Intermediate',
                lessionNumber : 7
            },
        ]
    },
    {
        tag: 'Most popular',
        courses : [
            {
                heading : "Java",
                description : "Learn the fundamentals of Java programming to build powerful and efficient applications.",
                level : 'Intermediate',
                lessionNumber : 15
            },
            {
                heading : "Python",
                description : "Explore Python basics and start building versatile applications quickly.",
                level : 'Beginner',
                lessionNumber : 10
            },
            {
                heading : "SCSS",
                description : "Enhance your CSS skills with SCSS to write cleaner and more maintainable stylesheets.",
                level : 'Intermediate',
                lessionNumber : 12
            },
        ]
    },
    {
        tag: 'Skills paths',
        courses : [
            {
                heading : "Flask",
                description : "Learn Flask to create robust backend applications with Python.",
                level : 'Beginner',
                lessionNumber : 10
            },
            {
                heading : "Django",
                description : "Master Django for developing scalable and secure web applications.",
                level : 'Intermediate',
                lessionNumber : 14
            },
            {
                heading : "Fast API",
                description : "Get started with FastAPI to build high-performance APIs effortlessly.",
                level : 'Intermediate',
                lessionNumber : 9
            },
        ]
    },
    {
        tag: 'Career paths',
        courses : [
            {
                heading : "Next.js",
                description : "Learn Next.js to build fast, SEO-friendly web applications with React.",
                level : 'Intermediate',
                lessionNumber : 16
            },
            {
                heading : "Nuxt.js",
                description : "Master Nuxt.js for creating powerful and server-side rendered Vue applications.",
                level : 'Intermediate',
                lessionNumber : 12
            },
            {
                heading : "Sanity",
                description : "Explore Sanity to create flexible and efficient content management systems.",
                level : 'Intermediate',
                lessionNumber : 10
            },
        ]
    },
]
